module.exports = __webpack_public_path__ + "img/vision-lamp.cd6f0c1a.png";